import { render, staticRenderFns } from "./CompanyAvatar.vue?vue&type=template&id=3b54a63c&scoped=true"
import script from "./CompanyAvatar.vue?vue&type=script&lang=js"
export * from "./CompanyAvatar.vue?vue&type=script&lang=js"
import style0 from "./CompanyAvatar.vue?vue&type=style&index=0&id=3b54a63c&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b54a63c",
  null
  
)

export default component.exports